/* tslint:disable */

declare var Object: any;
export interface SecurestorageInterface {
  "id"?: number;
}

export class Securestorage implements SecurestorageInterface {
  "id": number;
  constructor(data?: SecurestorageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Securestorage`.
   */
  public static getModelName() {
    return "Securestorage";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Securestorage for dynamic purposes.
  **/
  public static factory(data: SecurestorageInterface): Securestorage{
    return new Securestorage(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Securestorage',
      plural: 'Securestorages',
      path: 'Securestorages',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Securestorage.ts